import { styled } from 'linaria/react';

export const RoomParamsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: var(--space-150) var(--space-150) var(--space-200) var(--space-150);
  margin-bottom: var(--space-400);
  border: dashed 1px var(--secondary-blue-primary);
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    border-color: var(--secondary-blue-dark);
  }

  @media (--to-tablet) {
    padding: var(--space-150);
    margin-bottom: var(--space-400);
  }

  @media (--only-mobile) {
    margin-bottom: var(--space-400);
  }
`;

export const ParamsListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  column-gap: var(--space-300);
  row-gap: var(--space-200);

  @media (--only-mobile) {
    flex-wrap: nowrap;
  }
`;
